import React from "react";
import WeatherIcon from "./WeatherIcon";   
 import "./WeatherForecastDay.css";

export default function WeatherForecastDay(props){
    function day(){
        let date = new Date (props.data.dt*1000);
        let day = date.getDay();
        let days = [ "Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"]
        return  days[day];
            }
    return (
        <div className="Forecast-day">
           <div className="WeatherForecast-day">{day()}</div>  

<div className="WeatherForecast-temperatures">
<span className="WeatherForecast-temperature-max">{Math.round(props.data.temp.max)}°</span>🌡<span className="WeatherForecast-temperature-min">{Math.round(props.data.temp.min)}°</span>
          </div>
        <div className="WeatherForecastDescription">
        {props.data.weather[0].description}
      </div>
      <WeatherIcon code={props.data.weather[0].icon} size={36} />
        </div>
        );
}